import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlexiblePipe = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 16,
	viewBox: "0 0 60.0 16.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 8.0 A 5.0 8.0 0.0 1 1 10.0 8.0 A 5.0 8.0 0.0 1 0 20.0 8.0 A 5.0 8.0 0.0 1 1 30.0 8.0 A 5.0 8.0 0.0 1 0 40.0 8.0 A 5.0 8.0 0.0 1 1 50.0 8.0 A 5.0 8.0 0.0 1 0 60.0 8.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgFlexiblePipe;
